"use strict";

/* eslint-disable react/no-find-dom-node, react/no-string-refs, react/jsx-handler-names */
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _colr = _interopRequireDefault(require("./vendor/colr"));

function rgbaColor(r, g, b, a) {
  return "rgba(" + [r, g, b, a / 100].join(',') + ")";
}

var Alpha =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Alpha, _React$Component);

  function Alpha(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Alpha);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Alpha).call(this, props));
    var events = ['onMouseDown', 'onDrag', 'onDragEnd', 'pointMoveTo', 'getBackground'];
    events.forEach(function (e) {
      _this[e] = _this[e].bind((0, _assertThisInitialized2.default)(_this));
    });
    return _this;
  }

  (0, _createClass2.default)(Alpha, [{
    key: "onMouseDown",
    value: function onMouseDown(e) {
      var x = e.clientX;
      var y = e.clientY;
      this.pointMoveTo({
        x: x,
        y: y
      });
      window.addEventListener('mousemove', this.onDrag);
      window.addEventListener('mouseup', this.onDragEnd);
    }
  }, {
    key: "onDrag",
    value: function onDrag(e) {
      var x = e.clientX;
      var y = e.clientY;
      this.pointMoveTo({
        x: x,
        y: y
      });
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd(e) {
      var x = e.clientX;
      var y = e.clientY;
      this.pointMoveTo({
        x: x,
        y: y
      });
      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('mouseup', this.onDragEnd);
    }
  }, {
    key: "getBackground",
    value: function getBackground() {
      var _colr$fromHex$toRgbOb = _colr.default.fromHex(this.props.hex).toRgbObject(),
          r = _colr$fromHex$toRgbOb.r,
          g = _colr$fromHex$toRgbOb.g,
          b = _colr$fromHex$toRgbOb.b;

      var startColor = rgbaColor(r, g, b, 0);
      var endColor = rgbaColor(r, g, b, 100);
      var opacityGradient = "linear-gradient(to right, " + startColor + ", " + endColor + ")";
      return opacityGradient;
    }
  }, {
    key: "measureBounds",
    value: function measureBounds() {
      return _reactDom.default.findDOMNode(this).getBoundingClientRect();
    }
  }, {
    key: "pointMoveTo",
    value: function pointMoveTo(coords) {
      var rect = this.measureBounds();
      var width = rect.width;
      var left = coords.x - rect.left;
      left = Math.max(0, left);
      left = Math.min(left, width);
      var alpha = Math.floor(left / width * 100);
      this.props.onChange({
        alpha: alpha
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alpha = _this$props.alpha,
          className = _this$props.className;
      return _react.default.createElement("div", {
        className: (0, _classNames.default)('private-react-colorpicker--slider', 'private-react-colorpicker--alpha', className)
      }, _react.default.createElement("div", {
        ref: "bg",
        className: "private-react-colorpicker--bg",
        style: {
          background: this.getBackground()
        }
      }), _react.default.createElement("span", {
        style: {
          left: alpha + "%"
        }
      }), _react.default.createElement("div", {
        className: "private-react-colorpicker--handler",
        onMouseDown: this.onMouseDown
      }));
    }
  }]);
  return Alpha;
}(_react.default.Component);

exports.default = Alpha;
Alpha.propTypes = {
  alpha: _react.PropTypes.number,
  className: _react.PropTypes.string,
  hex: _react.PropTypes.string,
  onChange: _react.PropTypes.func
};
module.exports = exports.default;